// extracted by mini-css-extract-plugin
module.exports = {"s_project":"StartProject_s_project__2VuCq"};